var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuppliers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#aaa",
  fillRule: "evenodd",
  d: "M11.636 0H1.455C.655 0 0 .655 0 1.455v9.381c0 .51.218.946.655 1.237L6.545 16l5.891-3.927c.364-.291.655-.728.655-1.237V1.455c0-.8-.655-1.455-1.455-1.455ZM5.091 10.91 1.455 7.272l1.018-1.018L5.09 8.873l5.527-5.528 1.018 1.019-6.545 6.545Z"
})));
export default SvgSuppliers;